<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="pl-epigraph"><em class="italic">Grief fills the room up of my absent child… </em></p>
<p class="pl-citation">—<em class="italic">King John</em>, Act III, Scene iv, William Shakespeare</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?3b217b74